import { inject, injectable } from "inversify";
import {
  ClientPortalMeetingModel,
  ClientPortalMeetingsFilterModel,
  ICPLClientPortalMeetingsClient,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalMeetingsService {
  getMeetings(filterModel: ClientPortalMeetingsFilterModel): Promise<ClientPortalMeetingModel[]>;
  getMeeting(meetingID: number): Promise<ClientPortalMeetingModel>;
}

@injectable()
export class ClientPortalMeetingsService implements IClientPortalMeetingsService {
  @inject(SERVICE_TYPES.CPLClientPortalMeetingsClient)
  cplClientPortalMeetingsClient!: ICPLClientPortalMeetingsClient;

  getMeetings(filterModel: ClientPortalMeetingsFilterModel): Promise<ClientPortalMeetingModel[]> {
    return this.cplClientPortalMeetingsClient.getClientPortalMeetings(filterModel);
  }

  getMeeting(meetingID: number): Promise<ClientPortalMeetingModel> {
    return this.cplClientPortalMeetingsClient.getClientPortalMeeting(meetingID);
  }
}
